<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center mt-2">
        <h5 class="mb-0 text-primary"><i class="fas fa-file-text-o text-primary"></i> Info</h5>
      </div>
      <hr />
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label">Type<sup><span class="text-danger font-12">*</span></sup>
            :</label>
            <input type="text" class="form-control form-control-sm" v-model="Obj.type" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Name<sup><span class="text-danger font-12">*</span></sup>
            :</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.name" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Value :</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.value" />
        </div>
        <div class="col-md-9 text-end mt-1">
          <button class="btn btn-sm btn-darknavy me-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fa fa-times-circle  me-1"></i> Cancel</button>
        </div>
      </div>
      <ul v-if="errors.length" class="text-danger ps-3">
          <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
        </ul>
      <div class="row">
        <div class="col-md-9 table-responsive mt-2">
             <div class="progress mb-0 progress-sm" v-if="progress!=0">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress + '%' }"></div>
      </div>
          <DataTable v-if="progress==0" :columns="cols" :rows="rows" :pageSize="10"   :actions="{  edit: handleEdit, delete: handleDelete }" />
        </div>
      </div>
    </div>
  </div>
  <DelPopup :name="delObj.name" @delRecord="delRecord" @closeModal="delObj.name = ''"></DelPopup>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import { isRequired, validateForm } from '@/utils/validation.js';
import DataTable from "@/components/Common/DataTable.vue";
import { curdStatus, api } from '@/utils/helpers.js';
import { ref, onMounted} from 'vue'
  const  Obj = ref( { name: "", type: "", value: "", })
    const   msgObj= ref({ msg: "", role: "", show: false, })
    const   delObj = ref({})
    const   errors= ref({})
const cols=ref([
  { label: 'S.No', key: 'Sno' },
    { label: 'Type', key: 'type' },
  { label: 'Name', key: 'name' },
  { label: 'Value', key: 'value' }
]);
const handleEdit = (row) => {
    Obj.value = { ...row }
}
const handleDelete = (row) => {
  delObj.value = { ...row };
}
const rows=ref([])
const save = async() => {
    const fields = {
        Type: { value: Obj.value.type, validators: [isRequired], },
        Name: { value: Obj.value.name, validators: [isRequired], },
      };
      errors.value = validateForm(fields);
      if (Object.keys(errors.value).length === 0) {
        const { url, method, msg } = curdStatus(Obj.value);
        await api[method](`/info${url}`, Obj.value)
          .then((response) => {
            reset();
            msgObj.value = { msg: `Info ${msg} Successfuly`, role: "success", show: true, };
            loadData();
            console.log(response);
          })
          .catch((error) => { console.log(error); });
        }
      }
    const reset= async() => {
      Obj.value = {  name: "", type: "", value: "", };
      msgObj.value = { msg: "", role: "", show: false, };
      errors.value = {};
    }
     const progress = ref(0)
    const loadData = async () => {
  let direction = 1;
  let progressInterval = setInterval(() => {
    progress.value += direction;
    if (progress.value >= 100) {
      progress.value = 0;
    }
  }, 100);
  await api.get('/info/all').then((response) => {
   rows.value = response.data.map((item, i) => ({ ...item, Sno: i + 1 })); 
    progress.value = 0;
    clearInterval(progressInterval);
  });
};
    const delRecord= async() => {
      await api.delete(`/info/${delObj.value._id}`)
        .then(() => {
          delObj.value={};
          loadData();
          msgObj.value = { msg: "Info Deleted Successfuly.", role: "danger", show: true, };
        });
    }
     onMounted(() => { loadData() })
</script>